export const LOCATION_FACILITY_GROUPS = [
  {
    id: 'amenities',
    label: 'On-site amenities',
    options: [
      { id: 'wifi', label: 'Wi-Fi' },
      { id: 'bathroom', label: 'Bathroom / restroom' },
      { id: 'shower', label: 'Shower' },
      { id: 'baby-changing', label: 'Baby changing' },
      { id: 'waiting-lounge', label: 'Waiting lounge' },
      { id: 'seating', label: 'Seating area' },
      { id: 'vending-machine', label: 'Vending machine' },
      { id: 'drinking-water', label: 'Drinking water' },
      { id: 'free-coffee', label: 'Free coffee / tea' },
      { id: 'lockers', label: 'Lockers' },
      { id: 'laundry', label: 'Laundry' },
      { id: 'picnic-area', label: 'Picnic area' },
      { id: 'playground', label: 'Playground' },
      { id: 'kids-area', label: 'Kids area' },
      { id: 'pets-allowed', label: 'Pets allowed' },
      { id: 'prayer-room', label: 'Prayer room' },
      { id: 'atm', label: 'ATM' },
      { id: 'phone-charging', label: 'Device / USB charging' }
    ]
  },
  {
    id: 'food',
    label: 'Food, stay & retail',
    options: [
      { id: 'hotel', label: 'Hotel' },
      { id: 'restaurant', label: 'Restaurant' },
      { id: 'cafe', label: 'Cafe' },
      { id: 'bar', label: 'Bar' },
      { id: 'fast-food', label: 'Fast food' },
      { id: 'convenience-store', label: 'Convenience store' },
      { id: 'supermarket', label: 'Supermarket' },
      { id: 'mall', label: 'Shopping mall' }
    ]
  },
  {
    id: 'parking',
    label: 'Parking & access',
    options: [
      { id: 'parking-lot', label: 'Parking lot' },
      { id: 'covered-parking', label: 'Covered parking' },
      { id: 'underground-parking', label: 'Underground parking' },
      { id: 'carpool-parking', label: 'Carpool parking' },
      { id: 'overnight-parking', label: 'Overnight parking' },
      { id: 'truck-parking', label: 'Truck / HGV parking' },
      { id: 'trailer-accessible', label: 'Trailer accessible' },
      { id: 'motorcycle-parking', label: 'Motorcycle parking' },
      { id: 'bicycle-parking', label: 'Bicycle parking' },
      { id: 'disabled-access', label: 'Disabled / wheelchair access' },
      { id: 'elevator', label: 'Elevator' },
      { id: '24-7-access', label: '24/7 access' },
      { id: 'highway', label: 'Highway / motorway' },
      { id: 'park-and-ride', label: 'Park & ride' }
    ]
  },
  {
    id: 'services',
    label: 'Vehicle & site services',
    options: [
      { id: 'fuel-station', label: 'Fuel station' },
      { id: 'car-wash', label: 'Car wash' },
      { id: 'tire-inflation', label: 'Tire inflation' },
      { id: 'vacuum', label: 'Vacuum' },
      { id: 'workshop', label: 'Workshop / service' },
      { id: 'valet', label: 'Valet' },
      { id: 'solar-canopy', label: 'Solar canopy' },
      { id: 'lighting', label: 'Site lighting' },
      { id: 'shelter', label: 'Shelter / canopy' }
    ]
  },
  {
    id: 'safety',
    label: 'Safety & security',
    options: [
      { id: 'cctv', label: 'CCTV' },
      { id: 'security-guard', label: 'Security staff' },
      { id: 'emergency-phone', label: 'Emergency phone' },
      { id: 'first-aid', label: 'First aid' },
      { id: 'fire-extinguisher', label: 'Fire extinguisher' }
    ]
  },
  {
    id: 'transport',
    label: 'Public transport',
    options: [
      { id: 'airport', label: 'Airport' },
      { id: 'train-station', label: 'Train station' },
      { id: 'metro-station', label: 'Metro station' },
      { id: 'tram-stop', label: 'Tram stop' },
      { id: 'bus-stop', label: 'Bus stop' },
      { id: 'taxi-stand', label: 'Taxi stand' },
      { id: 'ferry-terminal', label: 'Ferry terminal' },
      { id: 'bike-sharing', label: 'Bike sharing' }
    ]
  },
  {
    id: 'nearby',
    label: 'Nearby venues',
    options: [
      { id: 'sport', label: 'Sports facility' },
      { id: 'gym', label: 'Gym' },
      { id: 'swimming-pool', label: 'Swimming pool' },
      { id: 'spa', label: 'Spa' },
      { id: 'recreation-area', label: 'Recreation area' },
      { id: 'nature', label: 'Nature / park' },
      { id: 'beach', label: 'Beach' },
      { id: 'camping', label: 'Camping' },
      { id: 'museum', label: 'Museum' },
      { id: 'cinema', label: 'Cinema / theater' },
      { id: 'hospital', label: 'Hospital' },
      { id: 'pharmacy', label: 'Pharmacy' },
      { id: 'office', label: 'Office / business park' },
      { id: 'conference', label: 'Conference center' },
      { id: 'university', label: 'School / university' },
      { id: 'residential', label: 'Residential' },
      { id: 'truck-stop', label: 'Truck stop' },
      { id: 'motorway-services', label: 'Motorway services' }
    ]
  }
]

export function normalizeFacilities(values) {
  if (!Array.isArray(values)) return []
  const seen = new Set()
  const next = []
  for (const value of values) {
    const id = String(value || '').trim()
    if (!id || seen.has(id)) continue
    seen.add(id)
    next.push(id)
  }
  return next
}
